

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : DASHBOARD : DETAIL : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)

export default theme => ({
    questionsanswered:{

    }
})